import { render, staticRenderFns } from "./vistaNoAutorizada.vue?vue&type=template&id=27d1f0c6&scoped=true&"
var script = {}
import style0 from "./vistaNoAutorizada.vue?vue&type=style&index=0&id=27d1f0c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1f0c6",
  null
  
)

export default component.exports